module.exports = __webpack_public_path__ + "static/media/ManagedPlatform.bc1ad8db.svg";